import axios from 'axios';
import { loginRequest } from '../authConfig';
import { msalInstance } from '../index';
import { getCurrentEnvironment } from '../utils/env';
 
const env = getCurrentEnvironment();
 
const API = axios.create({
    baseURL: env.REACT_APP_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    allowAbsoluteUrls: false
});
 
const cloudAPI = axios.create({
    baseURL: 'https://api.maersk.com/identity/cloud-identity',
    headers: {
        'Consumer-Key': env.REACT_APP_CONSUMER_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
   
})

cloudAPI.interceptors.request.use(async (config) => {
    const expStr = localStorage.getItem("tokenExp");
    const exp = expStr ? Number(expStr) : 0;
    console.debug("local storage",localStorage);
    let cloudToken = localStorage.getItem('cloudApiToken');
 
    console.debug("Current cloud API token in local storage:", cloudToken);
    console.debug("Token expiration time in local storage:", exp);
    if (!cloudToken || exp < Date.now()) {
        console.debug("Fetching new cloud API token");
        const account = msalInstance.getAllAccounts()[0];
        const msalResponse = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account
        });
        console.debug("MSAL Response:", msalResponse);
        const response = await axios.get(`${env.REACT_APP_BASE_URL}/UserManagement/GetCloudApiToken`,
            { headers: { Authorization: `Bearer ${msalResponse.accessToken}` } }
        );
        console.debug("Response from GetCloudApiToken:", response);
        if (response == null) {
            console.error("Failed to fetch cloud API token");
            throw new Error("Failed to fetch cloud API token");
        }
 
        cloudToken = response.data.access_token;
        const newExp = Number(response?.data.expires_on) * 1000;

        console.debug("New cloud API token:", cloudToken);
        console.debug("New token expiration time:", newExp);
        localStorage.setItem('cloudApiToken', response.data.access_token)
        localStorage.setItem('tokenExp', newExp.toString());
   
    }
    console.debug("Using generated cloud API token:", cloudToken);
 
    if (!cloudToken) {
        console.error("Cloud API token is null or undefined");
        throw new Error("Cloud API token missing after fetch");
    }
    console.debug("Setting Authorization header for cloud API request");
    
    config.headers.Authorization = `Bearer ${cloudToken}`;
    config.headers['Consumer-Key'] = env.REACT_APP_CONSUMER_KEY;
 
    return config;
});
 
 
API.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        const msalResponse = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account
        });
        config.headers.Authorization = `Bearer ${msalResponse.accessToken}`
        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);
 
export { API, cloudAPI };